// Modul zur Erfassung von einfachen Finanzierungs-Positionen
"use strict";

import module from "./module.js";
// import "./tests.spec.js"; // TODO

export default module;
